/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ name: NonNullable<unknown> }} Home_Greeting_AfternoonInputs */



/**
* | output |
* | --- |
* | "Good afternoon, {name}!" |
*
* @param {Home_Greeting_AfternoonInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const home_greeting_afternoon = /** @type {((inputs: Home_Greeting_AfternoonInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Home_Greeting_AfternoonInputs, { locale?: "en" | "de" }, {}>} */ ((i, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ (`Guten Tag, ${i?.name}!`)
	return /** @type {LocalizedString} */ (`Good afternoon, ${i?.name}!`)
});